import { useState, useEffect } from "react"
import Swal from "sweetalert2"
import { useDispatch, useSelector } from "react-redux"
import { Modal, Button } from "react-bootstrap"
import { Link, useNavigate, useParams, useLocation } from "react-router-dom"
import Loader from "../Common/Loader.jsx"
import {
  getBookedAppointmentsAction,
  addVitalsAction,
  markPatientCurrentAction,
  markPatientNextAction,
  removePatientAction,
  pauseDoctorQueueAction,
  markPatientEmergencyAction,
  markPatientCompleteAction,
  getEmergencyPatientsAction,
  sendReminderAction,
  uploadPatientPhotoAction,
  collectPaymentAction,
  sendFormLinkAction,
} from "../../../store/actions/ReceptionistAction"
import { regeneratePrescriptionAction } from "../../../store/actions/ServiceCallerPrescriptionAction.js"
import icon1 from "../../../../src/assets/images/medical-report.png"
import icon from "../../../../src/assets/images/VitalsSheet.png"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import CommonPaymentModal from "../Common/CommonPaymentModal"
import { fetchDoctorDashboardAction } from "../../../store/actions/DashboardCardAction.js"
import defaultAvatar from "../../../../src/assets/images/placeholder.jpg"
import { formatName } from "../../../utils/formatName.js"
import call from "../../../../src/assets/images/icons8-call-102.png"
import emergencyIcon from "../../../../src/assets/images/emergancy.png"
import cancel from "../../../../src/assets/images/cancel_app.png"
import remainder from "../../../../src/assets/images/calendar1.png"
import collectpayment from "../../../../src/assets/images/collect_payment.png"
import EmergencyFeedbackModal from "./EmergencyFeedbackModal"
import { getRepeatPrescriptionList } from "../../../services/ServiceCallerPrescriptionService.js"
import { handleSuccess, showErrorAlert } from "../../../services/ErrorHandlingService.js"
import { getPatientPrescriptionsAction } from "../../../store/actions/PrescriptionAction.js"
import pdfIcon from "../../../../src/assets/images/icons8-pdf-50.png"
import Markcurrent from "../../../../src/assets/images/check_11601272.png"
import Markasnext from "../../../../src/assets/images/next_189241.png"
import connect from "../../../../src/assets/images/social-media_12891222.png"
import axiosInstance from "../../../services/AxiosInstance"
import stopPrescription from "../../../../src/assets/images/icons8-history-96.png";
import PrescriptionHistoryModal from "../AppsMenu/Patients/Components/PrescriptionHistoryModal.jsx"
import { formatDate } from "../../../utils/dateUtils.js"
import Sharelink from "../../../../src/assets/images/share-link.png"
const Doctor = () => {
  const navigate = useNavigate()
  const [showVitalsModal, setShowVitalsModal] = useState(false)
  const { patientId } = useParams()
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [vitalsPatient, setVitalsPatient] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [selectedPatient, setSelectedPatient] = useState(null)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const userDetails = JSON.parse(localStorage.getItem("userDetails"))
  const admin_id = userDetails?.admin_id || 0
  const doctorId = JSON.parse(localStorage.getItem("doctorId"))
  const roleName = userDetails?.role_name
  const [submittingVitals, setSubmittingVitals] = useState(false)
  const dispatch = useDispatch()
  const [showEmergencyFeedbackModal, setShowEmergencyFeedbackModal] = useState(false)
  const [selectedEmergencyPatient, setSelectedEmergencyPatient] = useState(null)

  // Photo upload states
  const [photoPreviews, setPhotoPreviews] = useState({})
  const [photoModalPatient, setPhotoModalPatient] = useState(null)

  // Consolidated loading states
  const [actionLoading, setActionLoading] = useState({
    markingCurrent: null,
    markingNext: null,
    removing: null,
    emergencyMarking: null,
    completing: null,
    sendingReminder: null,
    downloading: null,
    uploadingPhoto: null,
    pausing: false,
    vitalsOpening: null,
    collectingPayment: false,
    viewingPrescription: null,
    generatingPrescription: false
  })

  // Use selectedDoctorAppointments (specific doctor) for doctor page
  const patients = useSelector((state) => state.receptionists?.selectedDoctorAppointments || [])
  const emergencyPatients = useSelector((state) => state.receptionists?.emergencyPatients || [])
  const isPaused = useSelector((state) => state.receptionists?.isPaused)
  const emergencyPatientList = useSelector((state) => state.receptionists?.emergencyPatientList || [])
  const [repeatPatients, setRepeatPatients] = useState([])
  const [selectedPrescriptions, setSelectedPrescriptions] = useState([])
  const [loadingPrescription, setLoadingPrescription] = useState(false)
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false)

  const currentPatient = patients.find(p => p.status === "Current")
  const nextPatient = patients.find(p => p.status === "Next")
  const waitingPatients = patients.filter(p => p.status === "Waiting")

  const dashboardData = useSelector((state) => state.dashboard.doctorDashboard || {})
  const todaysActivities = dashboardData?.TodaysActivities || [];
  const [showPrescriptionHistory, setShowPrescriptionHistory] = useState(false);
  const [selectedPatientForPrescription, setSelectedPatientForPrescription] = useState(null);
  const [sendingLinkPatientId, setSendingLinkPatientId] = useState(null);

  // Helper function to check if patient is emergency
  const isEmergencyPatient = (patient) => {
    return patient.is_emergency === "Yes" || patient.is_emergency === 1 || emergencyPatients.includes(patient.queue_id)
  }

  // Helper function to check if patient is last in queue
  const isLastPatientInQueue = (patient) => {
    const queuePatients = patients.filter((p) => p.status !== "Current")
    return queuePatients.length === 0 && patient.status === "Current"
  }

  // Helper function to check if patient can perform actions (has queue_id or is_presented is "Yes")
  const canPerformActions = (patient) => {
    if (patient.queue_id) return true;
    if (patient.is_presented === "Yes") return true;
    return false;
  }

  // Helper function to show scan patient alert
  const showScanPatientAlert = () => {
    Swal.fire({
      title: "Patient Not in Queue",
      text: "Please ask reception to scan the patient QR code first to add them to the queue before performing this action.",
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    })
  }

  // Helper function to get the appropriate ID for loading states
  const getLoadingId = (patient) => {
    return patient.queue_id || patient.patient_id;
  }

  // Get single highest priority status for patient
  const getPatientStatus = (patient) => {
    // Priority 1: Emergency (highest)
    if (isEmergencyPatient(patient)) {
      return {
        label: "Emergency",
        message: "",
        color: "#dc3545",
        icon: "fas fa-exclamation-triangle",
        priority: 1
      };
    }

    // Priority 2: Not Scanned
    if (patient.is_presented === "No") {
      return {
        label: "Not Scanned",
        
        color: "#495057",
        icon: "fas fa-qrcode",
        priority: 2
      };
    }

    // Priority 3: Form Pending
    if (patient.queueDetails?.questionnaire_filled === "No" || patient.questionnaire_filled === "No") {
      return {
        label: "Form Pending",
        color: "#ff9f40",
        icon: "fas fa-clipboard",
        priority: 3
      };
    }

    // Priority 4: Vitals Pending
    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0");

    if (isVitalsMissing) {
      return {
        label: "Vitals Pending",
        message: "",
        color: "#6c757d",
        icon: "fas fa-heartbeat",
        priority: 4
      };
    }

    // No status - patient is complete
    return null;
  };

  // Helper function to show pause alert
  const showPauseAlert = () => {
    Swal.fire({
      title: "Queue is Paused",
      text: "The patient queue is currently paused. Please resume the queue to perform this action.",
      icon: "warning",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    })
  }

  // Clean malformed patient photo URLs
  const getValidPhotoUrl = (photoUrl) => {
    if (!photoUrl) return defaultAvatar
    if ((photoUrl.match(/https:\/\//g) || []).length > 1) {
      const parts = photoUrl.split("https://")
      return "https://" + parts[parts.length - 1]
    }
    return photoUrl
  }

  const getTodayDate = () => {
    const today = new Date()
    return today.toISOString().split("T")[0]
  }

  // Fixed useEffect for repeat prescriptions - only depends on doctorId
  useEffect(() => {
    const fetchRepeatPrescriptions = async () => {
      if (!doctorId) return;

      try {
        const res = await getRepeatPrescriptionList(doctorId);

        if (res?.data?.status === "success") {
          const prescriptions = res.data.data || [];

          const mergedData = prescriptions.map((pres) => ({
            ...pres,
            disease_name: "-",
            last_visit_date: "-",
          }));

          setRepeatPatients(mergedData);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchRepeatPrescriptions();
  }, [doctorId]);// Only depend on doctorId, not patients

  useEffect(() => {
    dispatch(getEmergencyPatientsAction())
  }, [dispatch])

  useEffect(() => {
    setVitalsPatient(null)
    setShowVitalsModal(false)
    setUploadedFiles([])
  }, [location.pathname])

  useEffect(() => {
    dispatch(fetchDoctorDashboardAction())
  }, [dispatch])

  // Fixed appointments polling - fetch doctor's appointments every 5 seconds
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const today = getTodayDate();
        const currentDoctorId = doctorId || admin_id;

        // Only fetch this specific doctor's appointments (Yes + No payment types)
        await Promise.all([
          dispatch(getBookedAppointmentsAction(today, currentDoctorId, "Yes")),
          dispatch(getBookedAppointmentsAction(today, currentDoctorId, "No"))
        ]);
      } catch (error) {
        console.error("Failed to fetch appointments:", error);
      }
    };

    fetchAppointments();
    const interval = setInterval(fetchAppointments, 5000);
    return () => clearInterval(interval);
  }, [dispatch, doctorId, admin_id]);

  const handleViewPrescription = async (patient) => {
    setSelectedPatient(patient);
    setShowPrescriptionModal(true);
    setLoadingPrescription(true);

    const result = await dispatch(
      getPatientPrescriptionsAction({ patient_id: patient.patient_id })
    );

    setSelectedPrescriptions(result || []);
    setLoadingPrescription(false);
  };

  const handleOpenPrescriptionHistory = async (patient) => {
    setSelectedPatientForPrescription(patient);
    setLoadingPrescription(true);

    const result = await dispatch(
      getPatientPrescriptionsAction({
        patient_id: patient.patient_id
      })
    );

    setSelectedPrescriptions(result || []);
    setLoadingPrescription(false);
    setShowPrescriptionHistory(true);
  };

  const TotalAppointment = dashboardData.TotalAppointment || 0
  const TotalPatients = dashboardData.TotalPatients || 0
  const TodaysPendingPatientQueue = dashboardData.TodaysPendingPatientQueue || 0

  // Photo capture handler
  useEffect(() => {
    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return
      if (event.data.type !== "PHOTO_CAPTURED") return

      const source = localStorage.getItem("photoSource")
      const imageDataUrl = event.data.image

      fetch(imageDataUrl)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], `vitals_${Date.now()}.png`, { type: "image/png" })

          if (source === "vitals") {
            setVitalsPatient((prev) => ({
              ...prev,
              uploadedFile: file,
              uploadedFileName: file.name,
            }))
            setUploadedFiles([file])
          } else if (source === "queue") {
            const pid = localStorage.getItem("photoPatientId")
            if (pid) {
              const previewURL = URL.createObjectURL(file)
              setPhotoPreviews((prev) => ({
                ...prev,
                [pid]: previewURL,
              }))
              dispatch(uploadPatientPhotoAction(pid, file))
            }
          }
          localStorage.removeItem("photoSource")
          localStorage.removeItem("photoPatientId")
        })
    }

    window.addEventListener("message", onMessage)
    return () => window.removeEventListener("message", onMessage)
  }, [dispatch])

  const openCameraTab = () => {
    const newTab = window.open("", "_blank")
    if (newTab) {
      const mainOrigin = window.location.origin
      newTab.document.write(`
        <html>
          <body style="margin:0;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;background:#000;">
            <video id="video" autoplay playsinline style="width:100%;height:auto;max-height:80vh;border-radius:8px;"></video>
            <button id="snap" 
              style="
                margin-top:20px;
                width:70px;
                height:70px;
                border-radius:50%;
                border:5px solid #fff;
                background-color:rgba(255,255,255,0.1);
                cursor:pointer;
                position:relative;
                transition:all 0.2s ease;
              ">
              <span style="
                position:absolute;
                top:50%;
                left:50%;
                transform:translate(-50%,-50%);
                width:40px;
                height:40px;
                background:white;
                border-radius:50%;
                display:block;
                transition:0.1s;
              "></span>
            </button>
            <canvas id="canvas" style="display:none;"></canvas>
            <script>
              navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
                const video = document.getElementById('video');
                video.srcObject = stream;
                const canvas = document.getElementById('canvas');
                const snapBtn = document.getElementById('snap');
                snapBtn.onclick = () => {
                  canvas.width = video.videoWidth;
                  canvas.height = video.videoHeight;
                  canvas.getContext('2d').drawImage(video, 0, 0);
                  const dataUrl = canvas.toDataURL('image/png');
                  window.opener.postMessage({ type: 'PHOTO_CAPTURED', image: dataUrl }, '${mainOrigin}');
                  stream.getTracks().forEach(track => track.stop());
                  window.close();
                };
              }).catch(err => {
                alert('Camera access denied: ' + err.message);
                window.close();
              });
            </script>
          </body>
        </html>
      `)
    }
  }

  // Vitals handlers
  const handleVitalsOpen = (patient) => {
    if (!patient) return

    if (!canPerformActions(patient)) {
      showScanPatientAlert();
      return;
    }

    const loadingId = getLoadingId(patient)
    if (!loadingId) return

    setActionLoading(prev => ({ ...prev, vitalsOpening: loadingId }))
    setShowVitalsModal(true)

    const keyMap = {
      systolic_bp: "systolicBP",
      diastolic_bp: "diastolicBP",
      Oxygen_Saturation: "oxygenSaturation",
      blood_glucose_level: "bloodGlucose",
      pluse_rate: "pulseRate",
      temperature: "temperature",
      Allergies: "allergies",
      weight: "weight",
      height: "height",
      bmi: "bmi",
    }

    const transformedPatient = { queue_id: patient.queue_id }

    for (const key in keyMap) {
      if (patient[key] !== undefined && patient[key] !== null) {
        transformedPatient[keyMap[key]] = patient[key]
      }
    }

    if (transformedPatient.height) {
      const totalInches = transformedPatient.height / 2.54
      const feet = Math.floor(totalInches / 12)
      const inches = Math.round(totalInches % 12)
      transformedPatient.heightFeet = feet
      transformedPatient.heightInches = inches
    }

    if (patient.Reports_Upload) {
      const fileName = patient.Reports_Upload.split("/").pop()
      transformedPatient.uploadedFileName = fileName
      setUploadedFiles([{ name: fileName, url: patient.Reports_Upload, isExisting: true }])
    } else {
      transformedPatient.uploadedFileName = null
      setUploadedFiles([])
    }

    transformedPatient.uploadedFile = null
    setVitalsPatient(transformedPatient)
    localStorage.setItem("queue_id", patient.queue_id)
  }

  const handleVitalsClose = () => {
    setShowVitalsModal(false)
    setVitalsPatient(null)
    setUploadedFiles([])
    setActionLoading(prev => ({ ...prev, vitalsOpening: null }))
  }

  const handleVitalsChange = (e) => {
    const { name, value, files } = e.target
    setVitalsPatient((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }))
  }

  const handleWeightChange = (e) => {
    const value = e.target.value
    setVitalsPatient((prev) => {
      const height = prev?.height || 0
      const heightInM = height / 100
      const bmiValue = value && height ? (value / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        weight: value,
        bmi: bmiValue,
      }
    })
  }

  const handleHeightFeetChange = (e) => {
    const feet = parseFloat(e.target.value) || 0
    setVitalsPatient((prev) => {
      const inches = parseFloat(prev?.heightInches) || 0
      const cm = ((feet * 12) + inches) * 2.54
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = cm / 100
      const bmiValue = weight && cm ? (weight / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        heightFeet: feet,
        height: cm,
        bmi: bmiValue,
      }
    })
  }

  const handleHeightInchesChange = (e) => {
    const inches = parseFloat(e.target.value) || 0
    setVitalsPatient((prev) => {
      const feet = parseFloat(prev?.heightFeet) || 0
      const cm = ((feet * 12) + inches) * 2.54
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = cm / 100
      const bmiValue = weight && cm ? (weight / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        heightInches: inches,
        height: cm,
        bmi: bmiValue,
      }
    })
  }

  const handleHeightCmChange = (e) => {
    const value = parseFloat(e.target.value) || 0
    const totalInches = value / 2.54
    const feet = Math.floor(totalInches / 12)
    const inches = Math.round(totalInches % 12)
    setVitalsPatient((prev) => {
      const weight = parseFloat(prev?.weight) || 0
      const heightInM = value / 100
      const bmiValue = weight && value ? (weight / (heightInM * heightInM)).toFixed(2) : ""
      return {
        ...prev,
        height: value,
        heightFeet: feet,
        heightInches: inches,
        bmi: bmiValue,
      }
    })
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    const validTypes = ["image/jpeg", "image/png"]

    if (file && validTypes.includes(file.type)) {
      setVitalsPatient((prev) => ({
        ...prev,
        uploadedFile: file,
        uploadedFileName: file.name,
      }))
      setUploadedFiles([file])
    } else {
      alert("Only JPEG and PNG files are allowed.")
      e.target.value = null
      setVitalsPatient((prev) => ({ ...prev, uploadedFile: null, uploadedFileName: null }))
      setUploadedFiles([])
    }
  }

  const handleDelete = (index) => {
    const updatedFiles = [...uploadedFiles]
    updatedFiles.splice(index, 1)
    setUploadedFiles(updatedFiles)
    setVitalsPatient((prev) => ({ ...prev, uploadedFile: null, uploadedFileName: null }))
    const fileInput = document.getElementById("reports")
    if (fileInput) fileInput.value = ""
  }

  const handleView = (file) => {
    if (file.isExisting && file.url) {
      window.open(file.url, "_blank")
    } else if (file instanceof File) {
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, "_blank")
    } else {
      Swal.fire("Warning", "Cannot view this file type or URL is not available.", "warning")
    }
  }

  const handleOnSubmit = async (e) => {
    e.preventDefault()

    if (submittingVitals) return

    const v = vitalsPatient || {}

    const allEmpty =
      (!v.systolicBP || v.systolicBP === 0) &&
      (!v.diastolicBP || v.diastolicBP === 0) &&
      (!v.weight || v.weight === 0) &&
      (!v.height || v.height === 0) &&
      (!v.bmi || v.bmi === 0) &&
      (!v.pulseRate || v.pulseRate === 0) &&
      (!v.temperature || v.temperature === 0) &&
      (!v.oxygenSaturation || v.oxygenSaturation === 0) &&
      (!v.bloodGlucose || v.bloodGlucose === 0) &&
      (!v.allergies || v.allergies.trim() === "")

    if (allEmpty) {
      Swal.fire("Warning", "Please enter at least one vital before saving.", "warning")
      return
    }

    const queueId = v.queue_id || localStorage.getItem("queue_id")

    if (!queueId) {
      Swal.fire("Error", "No patient selected for vitals.", "error")
      return
    }

    setSubmittingVitals(true)

    const dataToSend = { queue_id: queueId }
    if (v.systolicBP) dataToSend.systolicBP = v.systolicBP
    if (v.diastolicBP) dataToSend.diastolicBP = v.diastolicBP
    if (v.oxygenSaturation) dataToSend.oxygenSaturation = v.oxygenSaturation
    if (v.bloodGlucose) dataToSend.bloodGlucose = v.bloodGlucose
    if (v.weight) dataToSend.weight = v.weight
    if (v.height) dataToSend.height = v.height
    if (v.bmi) dataToSend.bmi = v.bmi
    if (v.pulseRate) dataToSend.pulseRate = v.pulseRate
    if (v.temperature) dataToSend.temperature = v.temperature
    if (v.allergies) dataToSend.allergies = v.allergies.trim()

    if (v.uploadedFile) dataToSend.Reports_Upload = v.uploadedFile
    else if (v.uploadedFileName) dataToSend.Reports_Upload = v.uploadedFileName
    else dataToSend.Reports_Upload = null

    try {
      await dispatch(addVitalsAction(dataToSend))
      Swal.fire("Success!", "Vitals added successfully!", "success")
      setShowVitalsModal(false)
      setUploadedFiles([])
      setVitalsPatient(null)
      localStorage.removeItem("queue_id")
      const today = getTodayDate()
      dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
      setActionLoading(prev => ({ ...prev, vitalsOpening: null }))
    } catch (err) {
      console.error("Error adding vitals:", err)
      Swal.fire("Error", "Failed to add vitals", "error")
    } finally {
      setSubmittingVitals(false)
    }
  }

  const handlePatientClick = (patient) => {
    const pid = patient.patient_id || patient.id
    const isFirstTime = (patient.is_firsttime_visitor || "").toLowerCase() === "yes"

    if (isFirstTime) {
      navigate("/app-questionnaire", {
        state: {
          patientData: {
            ...patient,
            patient_id: pid,
          },
        },
      })
    } else {
      navigate(`/patients/patient-details/${pid}`)
    }
  }

  const handleMarkCurrent = async (patient) => {
    if (!canPerformActions(patient)) {
      showScanPatientAlert();
      return;
    }

    const loadingId = getLoadingId(patient);
    if (!loadingId) return;

    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0") &&
      (!patient.Allergies || patient.Allergies === "") &&
      (!patient.Reports_Upload || patient.Reports_Upload === "")

    if (isVitalsMissing) {
      Swal.fire({
        icon: "warning",
        title: "Vitals Not Added",
        text: "Please add vitals before marking patient as Current.",
      })
      return
    }

    if (isPaused) {
      showPauseAlert();
      return;
    }

    if (actionLoading.markingCurrent === loadingId) return

    setActionLoading(prev => ({ ...prev, markingCurrent: loadingId }))

    try {
      await dispatch(markPatientCurrentAction(patient.queue_id))
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, admin_id, "Yes"))
      await dispatch(getBookedAppointmentsAction(today, admin_id, "No"))
      handleSuccess("Patient Marked as Current", `${patient.name} is now the current patient.`)
    } catch (err) {
      console.error("Mark current failed", err)
      showErrorAlert("Failed to mark patient as current")
    } finally {
      setActionLoading(prev => ({ ...prev, markingCurrent: null }))
    }
  }

  const handleMarkNext = async (patient) => {
    if (!canPerformActions(patient)) {
      showScanPatientAlert();
      return;
    }

    const loadingId = getLoadingId(patient);
    if (!loadingId) return;

    const isVitalsMissing =
      (!patient.systolic_bp || patient.systolic_bp === "0") &&
      (!patient.diastolic_bp || patient.diastolic_bp === "0") &&
      (!patient.weight || patient.weight === "0") &&
      (!patient.height || patient.height === "0") &&
      (!patient.bmi || patient.bmi === "0") &&
      (!patient.pluse_rate || patient.pluse_rate === "0") &&
      (!patient.temperature || patient.temperature === "0") &&
      (!patient.Oxygen_Saturation || patient.Oxygen_Saturation === "0") &&
      (!patient.blood_glucose_level || patient.blood_glucose_level === "0") &&
      (!patient.Allergies || patient.Allergies === "") &&
      (!patient.Reports_Upload || patient.Reports_Upload === "")

    if (isVitalsMissing) {
      Swal.fire({
        icon: "warning",
        title: "Vitals Not Added",
        text: "Please add vitals before marking patient as Next.",
      })
      return
    }

    if (isPaused) {
      showPauseAlert();
      return;
    }

    if (actionLoading.markingNext === loadingId) return

    setActionLoading(prev => ({ ...prev, markingNext: loadingId }))

    try {
      await dispatch(markPatientNextAction(patient.queue_id))
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id, "Yes"))
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id, "No"))
      handleSuccess("Patient Marked as Next", `${patient.name} is now the next patient.`)
    } catch (err) {
      console.error("Mark next failed", err)
      showErrorAlert("Failed to mark patient as next")
    } finally {
      setActionLoading(prev => ({ ...prev, markingNext: null }))
    }
  }

  const handleEmergency = async (patient) => {
    if (!patient) return

    if (!canPerformActions(patient)) {
      showScanPatientAlert();
      return;
    }

    const loadingId = getLoadingId(patient)
    if (!loadingId) return

    if (actionLoading.emergencyMarking === loadingId) return

    const isCurrentlyEmergency = isEmergencyPatient(patient)

    const result = await Swal.fire({
      title: isCurrentlyEmergency ? "Remove Emergency Status" : "Mark as Emergency",
      text: `Are you sure you want to ${isCurrentlyEmergency ? "remove emergency status from" : "mark"} ${patient.name} ${isCurrentlyEmergency ? "" : "as emergency"}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isCurrentlyEmergency ? "#28a745" : "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: isCurrentlyEmergency ? "Yes, remove emergency" : "Yes, mark as emergency",
      cancelButtonText: "Cancel",
    })

    if (!result.isConfirmed) return

    setActionLoading(prev => ({ ...prev, emergencyMarking: loadingId }))

    try {
      await dispatch(markPatientEmergencyAction(patient.queue_id))
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
      Swal.fire({
        icon: "success",
        title: isCurrentlyEmergency ? "Emergency Status Removed" : "Marked as Emergency",
        text: `${patient.name} ${isCurrentlyEmergency ? "is no longer" : "is now"} marked as emergency.`,
        timer: 2000,
        showConfirmButton: false,
      })
    } catch (error) {
      console.error("Emergency marking failed:", error)
      Swal.fire("Error", "Failed to update emergency status.", "error")
    } finally {
      setActionLoading(prev => ({ ...prev, emergencyMarking: null }))
    }
  }

  // const handleMarkComplete = async (patient) => {
  //   try {
  //     const result = await Swal.fire({
  //       title: "Mark as Complete",
  //       text: `Are you sure you want to mark ${patient.name} as complete? This will remove them from the queue.`,
  //       icon: "question",
  //       showCancelButton: true,
  //       confirmButtonColor: "#28a745",
  //       cancelButtonColor: "#6c757d",
  //       confirmButtonText: "Yes, mark as complete",
  //       cancelButtonText: "Cancel",
  //     })

  //     if (result.isConfirmed) {
  //       if (actionLoading.completing === patient.queue_id) return

  //       setActionLoading(prev => ({ ...prev, completing: patient.queue_id }))

  //       await dispatch(markPatientCompleteAction(patient.queue_id))
  //       const today = getTodayDate()
  //       dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
  //     }
  //   } catch (error) {
  //     console.error("Mark complete failed:", error)
  //     Swal.fire("Error", "Failed to mark patient as complete", "error")
  //   } finally {
  //     setActionLoading(prev => ({ ...prev, completing: null }))
  //   }
  // }
  const handleMarkComplete = async (patient) => {

    try {
  
      const result = await Swal.fire({
        title: "Mark as Complete",
        text: `Are you sure you want to mark ${patient.name} as complete? This will remove them from the queue.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText:
          "Yes, mark as complete",
        cancelButtonText: "Cancel",
      });
  
      if (result.isConfirmed) {
  
        if (
          actionLoading.completing ===
          patient.queue_id
        ) {
          return;
        }
  
        setActionLoading((prev) => ({
          ...prev,
          completing: patient.queue_id,
        }));
  
        await dispatch(
          markPatientCompleteAction(
            patient.queue_id
          )
        );
  
        const today =
          getTodayDate();
  
        await dispatch(
          getBookedAppointmentsAction(
            today,
            doctorId || admin_id
          )
        );
  
        // handleSuccess(
          
        //   `${patient.name} marked as complete successfully.`
        // );
  
      }
  
    } catch (error) {
  
      console.error(
        "Mark complete failed:",
        error
      );
  
      showErrorAlert(
        "Failed to mark patient as complete"
      );
  
    } finally {
  
      setActionLoading((prev) => ({
        ...prev,
        completing: null,
      }));
  
    }
  
  };

  const handleRemovePatient = async (patient) => {
    if (!patient) return

    if (!canPerformActions(patient)) {
      showScanPatientAlert();
      return;
    }

    const loadingId = getLoadingId(patient)
    if (!loadingId) return

    if (actionLoading.removing === loadingId) return

    setActionLoading(prev => ({ ...prev, removing: loadingId }))

    try {
      await dispatch(removePatientAction(patient))
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
    } catch (e) {
      console.error("Remove patient failed:", e)
      showErrorAlert("Failed to remove patient")
    } finally {
      setActionLoading(prev => ({ ...prev, removing: null }))
    }
  }

  const handlePauseAll = async () => {
    if (actionLoading.pausing) return

    const actionText = isPaused ? "resume" : "pause"
    const actionTitle = isPaused ? "Resume Doctor Queue" : "Pause Doctor Queue"
    const confirmText = isPaused ? "Yes, resume queue" : "Yes, pause queue"

    Swal.fire({
      title: actionTitle,
      text: `Are you sure you want to ${actionText} your patient queue?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: isPaused ? "#28a745" : "#f6c23e",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmText,
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return

      setActionLoading(prev => ({ ...prev, pausing: true }))

      try {
        const pauseValue = isPaused ? "No" : "Yes"
        await dispatch(pauseDoctorQueueAction(doctorId || admin_id, pauseValue))
        const today = getTodayDate()
        await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
      } catch (error) {
        console.error("Queue action failed:", error)
        showErrorAlert("Failed to pause/resume queue.")
      } finally {
        setActionLoading(prev => ({ ...prev, pausing: false }))
      }
    })
  }

  const handleSendReminder = async (appointmentId) => {
    if (!appointmentId) return
    if (actionLoading.sendingReminder === appointmentId) return

    setActionLoading(prev => ({ ...prev, sendingReminder: appointmentId }))

    try {
      await dispatch(sendReminderAction(appointmentId))
      const today = getTodayDate()
      dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
    } catch (err) {
      console.error("Reminder error:", err)
      showErrorAlert("Failed to send reminder")
    } finally {
      setActionLoading(prev => ({ ...prev, sendingReminder: null }))
    }
  }

  const handleSendLink = async (patientId) => {
    setSendingLinkPatientId(patientId)
    try {
      await dispatch(sendFormLinkAction(patientId))
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
      // handleSuccess("Link Sent", "Form link sent to patient successfully")
    } catch (error) {
      console.error("Send link error:", error)
      Swal.fire("Error", "Failed to send form link", "error")
    } finally {
      setSendingLinkPatientId(null)
    }
  }

  const handleDownloadReceipt = async (url, paymentId) => {
    if (actionLoading.downloading === paymentId) return

    setActionLoading(prev => ({ ...prev, downloading: paymentId }))

    try {
      const link = document.createElement("a")
      link.href = url
      link.download = "receipt.pdf"
      link.target = "_blank"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      console.error("Failed to download receipt:", error)
      showErrorAlert("Failed to download receipt")
    } finally {
      setTimeout(() => setActionLoading(prev => ({ ...prev, downloading: null })), 1000)
    }
  }

  const handleCollectPayment = (patient) => {
    setSelectedPatient(patient)
    setShowModal(true)
  }

  const handlePaymentSubmit = async (paymentData) => {
    setActionLoading(prev => ({ ...prev, collectingPayment: true }))

    try {
      const formData = {
        queue_id: selectedPatient?.queue_id,
        patient_id: selectedPatient?.patient_id,
        amount: paymentData.amount,
        payment_type: paymentData.paymentType,
        payment_for: "APPOINTMENT",
        coupon_code: paymentData.couponCode || "",
        final_amount: paymentData.finalAmount,
        reference_id: "",
      }
      await dispatch(collectPaymentAction(formData))
      handleSuccess("Payment collected successfully!")
      const today = getTodayDate()
      await dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
      setShowModal(false)
      setSelectedPatient(null)
    } catch (error) {
      console.error("Payment error:", error)
      showErrorAlert("Payment failed. Please try again.")
    } finally {
      setActionLoading(prev => ({ ...prev, collectingPayment: false }))
    }
  }

  const handleUploadPatientPhoto = async (patient, file) => {
    if (!patient?.patient_id || !file) return

    setActionLoading(prev => ({ ...prev, uploadingPhoto: patient.patient_id }))

    try {
      await dispatch(uploadPatientPhotoAction(patient.patient_id, file))
      Swal.fire({
        icon: "success",
        title: "Photo Uploaded",
        text: "Patient photo uploaded successfully!",
        timer: 1500,
        showConfirmButton: false,
      })
      const today = getTodayDate()
      dispatch(getBookedAppointmentsAction(today, doctorId || admin_id))
    } catch (error) {
      console.error("Photo upload error:", error)
      Swal.fire("Error", "Failed to upload photo", "error")
    } finally {
      setActionLoading(prev => ({ ...prev, uploadingPhoto: null }))
    }
  }

  const handleOpenAndShare = (patientId) => {
    window.open(`/case-paper/${patientId}`, "_blank", "noopener,noreferrer")
    const url = `${window.location.origin}/case-paper/${patientId}`
    const message = `Case Paper:\n${url}`
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`
    setTimeout(() => {
      window.open(whatsappUrl, "_blank", "noopener,noreferrer")
    }, 300)
  }

  const handleEmergencyFeedbackSave = async (data) => {
    try {
      const payload = {
        doctor_id: doctorId || admin_id,
        patient_id: selectedEmergencyPatient?.patient_id,
        service_call_frequency: data.service_call_frequency,
        feedback: data.feedback
      }
      const response = await axiosInstance.post("/doctor/addFeedback", payload)
      if (response?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Feedback added successfully",
          timer: 2000,
          showConfirmButton: false
        })
        setShowEmergencyFeedbackModal(false)
        setSelectedEmergencyPatient(null)
        dispatch(getEmergencyPatientsAction())
      }
    } catch (error) {
      console.error("Feedback API error:", error)
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add feedback"
      })
    }
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <div>
      <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
        <div className="me-auto d-none d-lg-block">
          <h3 className="text-black font-w600">Welcome to Rohati Ayurved!</h3>
        </div>
      </div>

      {/* Dashboard Cards */}
      <div className="row">
        <div className="col-xl-6 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-danger rounded">
            <div className="card-body" style={{ padding: "15px" }}>
              <div className="media align-items-center mb-2">
                <div className="media-body">
                  <h1 className="mb-1" style={{ fontSize: "18px", fontWeight: "600", color: "white" }}>
                    Appointments
                  </h1>
                </div>
                <span className="border rounded-circle p-3">
                  <svg width={28} height={28} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M23.6667 0.333311C21.1963 0.264777 18.7993 1.17744 17 2.87164C15.2008 1.17744 12.8038 0.264777 10.3334 0.333311C8.9341 0.337244 7.55292 0.649469 6.28803 1.24778C5.02315 1.84608 3.90564 2.71577 3.01502 3.79498C-0.039984 7.45998 -0.261651 13.3333 1.19668 17.5966C1.21002 17.6266 1.22002 17.6566 1.23335 17.6866C3.91168 25.3333 15.2717 33.6666 17 33.6666C18.6983 33.6666 30.025 25.5166 32.7667 17.6866C32.78 17.6566 32.79 17.6266 32.8034 17.5966C34.2417 13.4016 34.0867 7.51498 30.985 3.79498C30.0944 2.71577 28.9769 1.84608 27.712 1.24778C26.4471 0.649469 25.0659 0.337244 23.6667 0.333311ZM17 30.03C14.6817 28.5233 8.23168 24 5.30335 18.6666H12C12.2743 18.6667 12.5444 18.599 12.7863 18.4696C13.0282 18.3403 13.2344 18.1532 13.3867 17.925L14.83 15.7583L17.0867 22.525C17.1854 22.8207 17.3651 23.0829 17.6054 23.2816C17.8456 23.4803 18.1368 23.6076 18.4458 23.6491C18.7548 23.6906 19.0693 23.6446 19.3535 23.5163C19.6376 23.388 19.8801 23.1825 20.0533 22.9233L22.8917 18.6666H28.6984C25.7684 24 19.3183 28.5233 17 30.03ZM29.975 15.3333H22C21.7257 15.3333 21.4556 15.4009 21.2137 15.5303C20.9718 15.6597 20.7656 15.8468 20.6133 16.075L19.17 18.2416L16.9133 11.475C16.8146 11.1792 16.6349 10.9171 16.3947 10.7184C16.1544 10.5196 15.8632 10.3923 15.5542 10.3508C15.2452 10.3093 14.9307 10.3553 14.6466 10.4837C14.3624 10.612 14.1199 10.8174 13.9467 11.0766L11.1084 15.3333H4.02502C3.35835 12.1816 3.50502 8.41164 5.57668 5.92831C6.151 5.22081 6.87614 4.65057 7.69911 4.25927C8.52209 3.86797 9.42209 3.6655 10.3334 3.66664C15.445 3.66664 14.9117 7.16664 16.9817 7.18664H17C19.0733 7.18664 18.5483 3.66664 23.6667 3.66664C24.5785 3.665 25.4792 3.86723 26.3027 4.25855C27.1263 4.64987 27.852 5.22037 28.4267 5.92831C30.4867 8.40331 30.6467 12.1666 29.975 15.3333Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </div>
              <div className="row text-center mt-2">
                {[
                  { title: "Total Appointments", count: dashboardData.TotalAppointment || 0, bg: "#4e73df" },
                  { title: "Total Patients", count: dashboardData.TotalPatients || 0, bg: "#1cc88a" },
                  { title: "Pending Patient", count: dashboardData.TodaysPendingPatientQueue || 0, bg: "#f6c23e" },
                ].map((item, index) => (
                  <div className="col-12 col-md-4 mb-2" key={index}>
                    <div>
                      <h6 className="mb-1" style={{ color: "white", fontSize: "16px", fontWeight: "500" }}>
                        {item.title}
                      </h6>
                      <p style={{ color: "white", fontSize: "24px", fontWeight: "700", marginBottom: "0" }}>
                        {item.count}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-6 col-xxl-6 col-sm-6">
          <div className="card gradient-bx text-white bg-info rounded">
            <div className="card-body" style={{ padding: "15px" }}>
              <div className="media align-items-center mb-2">
                <div className="media-body">
                  <h1 className="mb-1" style={{ fontSize: "18px", fontWeight: "600", color: "white" }}>
                    Today's Activities
                  </h1>
                </div>
                <span className="border rounded-circle p-3">
                  <svg width={28} height={28} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="18" fill="white" opacity="0.25" />
                    <circle cx="20" cy="20" r="10" fill="white" />
                  </svg>
                </span>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    style={{
                      maxHeight: "100px",
                      overflowY: "auto",
                    }}
                  >
                    <div style={{ width: "100%", color: "white", fontSize: "13px" }}>

                      {/* Header */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr",
                          fontWeight: "600",
                          borderBottom: "1px solid rgba(255,255,255,0.3)",
                          paddingBottom: "4px",
                          marginBottom: "4px",
                        }}
                      >
                        <span>Date</span>
                        <span>Time</span>
                        <span>Mode</span>
                        <span>Status</span>
                      </div>

                      {/* Rows */}
                      {todaysActivities.length > 0 ? (
                        todaysActivities.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr 1fr 1fr",
                              padding: "3px 0",
                            }}
                          >
                            <span>{formatDate(item.date)}</span>
                            <span>{item.time_slot || "N/A"}</span>
                            <span>{item.mode}</span>
                            <span
                              style={{
                                color:
                                  item.patient_marked === "Complete"
                                    ? "#00ffcc"
                                    : "#fff",
                                fontWeight: "600",
                              }}
                            >
                              {item.patient_marked}
                            </span>
                          </div>
                        ))
                      ) : (
                        <div>No activities for today</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Queue Section */}
      <div className="row mb-3">
        <div className="col-xl-12">
          <div className="card border-0 pb-0">
            <div className="card-body">
              <div className="row">
                {/* Left Column - Current and Next Patient */}
                <div className="col-xl-6 col-xxl-6 col-lg-6">
                  {/* Current Patient */}
                  <h4 className="card-title mb-3">Current Patient</h4>

                  {!currentPatient ? (
                    <div
                      className="d-flex justify-content-center align-items-center border rounded"
                      style={{ height: "200px", minHeight: "200px" }}
                    >
                      <p className="text-muted text-center m-0">No current patient.</p>
                    </div>
                  ) : (
                    <div className="p-4 border rounded bg-white w-100 mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleMarkComplete(currentPatient)}
                          title="Mark as Complete"
                          style={{ padding: "6px 10px", fontSize: "13px" }}
                          disabled={actionLoading.completing === currentPatient.queue_id}
                        >
                          {actionLoading.completing === currentPatient.queue_id ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1"></span>
                              Completing...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-check-double me-1"></i>
                              Complete
                            </>
                          )}
                        </button>

                        <div
                          className="d-flex align-items-center justify-content-end flex-wrap gap-3"
                          style={{ minHeight: "40px" }}
                        >
                          {isEmergencyPatient(currentPatient) && (
                            <span
                              className="d-inline-flex align-items-center"
                              style={{
                                backgroundColor: "#dc3545",
                                color: "white",
                                padding: "4px 8px",
                                borderRadius: "8px",
                                fontSize: "12px",
                                fontWeight: "bold",
                                height: "28px",
                              }}
                            >
                              <i className="fas fa-exclamation-triangle me-1"></i>
                              EMERGENCY
                            </span>
                          )}

                          <Link
                            to="#"
                            title="Preview Patient"
                            className="d-inline-flex align-items-center justify-content-center"
                            style={{ width: "28px", height: "28px" }}
                            onClick={(e) => {
                              e.preventDefault()
                              handlePatientClick(currentPatient)
                            }}
                          >
                            <i className="fa fa-eye text-primary fs-6"></i>
                          </Link>

                          <img
                            src={icon1}
                            alt="Case Paper"
                            title="Open & Share Case Paper"
                            onClick={() => handleOpenAndShare(currentPatient?.patient_id || currentPatient?.id)}
                            style={{ cursor: "pointer", width: "24px", height: "24px" }}
                          />

                          {!canPerformActions(currentPatient) ? (
                            <span
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                              title="Please ask reception to scan patient first"
                              onClick={showScanPatientAlert}
                            >
                              <img
                                src={icon}
                                alt="Vitals Disabled"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  filter: "grayscale(100%)",
                                }}
                              />
                            </span>
                          ) : actionLoading.vitalsOpening &&
                            (actionLoading.vitalsOpening === currentPatient.queue_id ||
                              actionLoading.vitalsOpening === currentPatient.patient_id) ? (
                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                          ) : (
                            <Link
                              to="#"
                              title="Vitals"
                              className="d-inline-flex align-items-center justify-content-center"
                              style={{ width: "28px", height: "28px" }}
                              onClick={(e) => {
                                e.preventDefault()
                                handleVitalsOpen(currentPatient)
                              }}
                            >
                              <img
                                src={icon}
                                alt="Vitals"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  cursor: "pointer",
                                }}
                              />
                            </Link>
                          )}
                        </div>
                      </div>

                      <div className="text-center mb-4">
                        <div style={{ position: "relative", display: "inline-block" }}>
                          {actionLoading.uploadingPhoto === currentPatient.patient_id ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ width: "120px", height: "120px" }}>
                              <span className="spinner-border text-primary" role="status" aria-hidden="true"></span>
                            </div>
                          ) : (
                            <img
                              alt="avatar"
                              width="120"
                              height="120"
                              src={photoPreviews[currentPatient.patient_id] || getValidPhotoUrl(currentPatient?.patient_photo)}
                              onError={(e) => {
                                e.target.onerror = null
                                e.target.src = defaultAvatar
                              }}
                              className="rounded-circle border"
                              style={{
                                objectFit: "cover",
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                border: isEmergencyPatient(currentPatient) ? "4px solid #dc3545" : "4px solid #e5e7eb",
                                transition: "0.3s",
                              }}
                              onClick={() => setPhotoModalPatient(currentPatient)}
                            />
                          )}

                          <input
                            type="file"
                            id={`choose-photo-${currentPatient?.patient_id}`}
                            accept="image/jpeg,image/png"
                            style={{ display: "none" }}
                            onChange={async (e) => {
                              const file = e.target.files[0]
                              if (!file || !currentPatient?.patient_id) return

                              const previewUrl = URL.createObjectURL(file)
                              setPhotoPreviews((prev) => ({
                                ...prev,
                                [currentPatient.patient_id]: previewUrl,
                              }))

                              try {
                                await handleUploadPatientPhoto(currentPatient, file)
                              } catch (err) {
                                console.error("Upload error:", err)
                                setPhotoPreviews((prev) => {
                                  const updated = { ...prev }
                                  delete updated[currentPatient.patient_id]
                                  return updated
                                })
                              }
                            }}
                          />

                          <input
                            type="file"
                            id={`take-photo-${currentPatient?.patient_id}`}
                            accept="image/jpeg,image/png"
                            capture="environment"
                            style={{ display: "none" }}
                            onChange={async (e) => {
                              const file = e.target.files[0]
                              if (!file || !currentPatient?.patient_id) return

                              const previewUrl = URL.createObjectURL(file)
                              setPhotoPreviews((prev) => ({
                                ...prev,
                                [currentPatient.patient_id]: previewUrl,
                              }))

                              try {
                                await handleUploadPatientPhoto(currentPatient, file)
                              } catch (err) {
                                console.error("Upload error:", err)
                                setPhotoPreviews((prev) => {
                                  const updated = { ...prev }
                                  delete updated[currentPatient.patient_id]
                                  return updated
                                })
                              }
                            }}
                          />
                        </div>

                        <h5
                          className="mt-3 mb-0 fw-bold text-dark d-flex justify-content-center align-items-center"
                          style={{
                            gap: "8px",
                            whiteSpace: "nowrap"
                          }}
                        >
                          <span>{currentPatient?.name || ""}</span>

                          {currentPatient?.partner_name && (
                            <span className="d-flex align-items-center" style={{ gap: "4px" }}>
                              <img
                                src={connect}
                                alt="Partner"
                                width="18"
                                height="18"
                                style={{ cursor: "pointer" }}
                                title={`Call ${currentPatient.partner_name}`}
                                onClick={() => {
                                  if (currentPatient?.partner_phone) {
                                    window.location.href = `tel:${currentPatient.partner_phone}`;
                                  }
                                }}
                              />
                              <span>{currentPatient.partner_name}</span>
                            </span>
                          )}

                          {(() => {
                            const status = getPatientStatus(currentPatient);
                            if (!status) {
                              return (
                                <span className="badge bg-primary">
                                  {currentPatient?.status}
                                </span>
                              );
                            }
                            return (
                              <div
                                style={{
                                  backgroundColor: status.priority === 1 ? "rgba(220, 53, 69, 0.1)" : "rgba(100, 100, 100, 0.05)",
                                  color: status.color,
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  display: "inline-flex",
                                  flexDirection: "column",
                                  gap: "2px",
                                  lineHeight: 1.2,
                                  border: `1px solid ${status.color}33`
                                }}
                              >
                                <span style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                  <i className={status.icon}></i>
                                  <strong>{status.label}</strong>
                                </span>
                                {status.message && (
                                  <span style={{ fontSize: "9px", fontWeight: "400", opacity: 0.9 }}>
                                    {status.message}
                                  </span>
                                )}
                              </div>
                            );
                          })()}
                        </h5>
                      </div>

                      <div className="row px-2 py-3 bg-gray-50 rounded">
                        {[
                          { label: "Gender", value: currentPatient.gender || "-" },
                          { label: "Age", value: currentPatient.age ? `${currentPatient.age} years` : "-" },
                          { label: "Weight", value: currentPatient.weight ? `${currentPatient.weight} kg` : "-" },
                          { label: "Occupation", value: currentPatient.occupation || "-" },
                          // { label: "City", value: currentPatient.city || "N/A" },
                          { label: "City", value: currentPatient.city || currentPatient?.parentCity || "-" },
                          { label: "Contact", value: currentPatient.whatsapp_contact_no || "-" },
                          { label: "Marital", value: currentPatient.marital_status || "-" },
                          { label: "Disease", value: currentPatient.diseases || "-" },
                        ].map((item, index, arr) => {
                          const lastRowStart = arr.length - (arr.length % 3 || 3)
                          return (
                            <div
                              key={index}
                              className="col-md-4 col-sm-6 py-2 text-wrap"
                              style={{
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                marginBottom: "4px",
                                borderBottom: index >= lastRowStart ? "none" : "1px solid #ddd",
                              }}
                            >
                              <strong className="text-gray-700">{item.label}: </strong>
                              <span className="ml-2 text-gray-900">{item.value}</span>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )}

                  {/* Next Patient Section */}
                  <div className="border-0 pb-0" style={{ marginTop: "10px" }}>
                    <div className="pb-0 d-flex flex-wrap justify-content-between align-items-center gap-2">
                      <h4 className="card-title mb-0" style={{ fontWeight: 600 }}>
                        Next Patient
                      </h4>
                    </div>

                    <div className="pt-3">
                      {nextPatient ? (
                        <ul className="timeline">
                          {(() => {
                            const patient = nextPatient

                            return (
                              <li key={patient.queue_id}>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    backgroundColor: isEmergencyPatient(patient)
                                      ? "rgba(220, 53, 69, 0.1)"
                                      : patient.questionnaire_filled === "No"
                                        ? "rgba(135, 206, 250, 0.3)"
                                        : "transparent",
                                    border: isEmergencyPatient(patient)
                                      ? "2px solid rgba(220, 53, 69, 0.3)"
                                      : patient.questionnaire_filled === "No"
                                        ? "2px solid rgba(135, 206, 250, 0.6)"
                                        : "1px solid #e9ecef",
                                    borderRadius: "8px",
                                    padding: "15px",
                                    marginBottom: "10px",
                                    transition: "all 0.3s ease",
                                    position: "relative",
                                  }}
                                >
                                  <div className="d-flex align-items-start w-100">
                                    <div className="media me-2">
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        {actionLoading.uploadingPhoto === patient.patient_id ? (
                                          <div className="d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px" }}>
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "50%",

                                            }}
                                          >
                                            <img
                                              alt="avatar"
                                              src={
                                                photoPreviews[patient.patient_id] ||
                                                getValidPhotoUrl(patient?.patient_photo)
                                              }
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultAvatar;
                                              }}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                display: "block",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => setPhotoModalPatient(patient)}
                                            />
                                          </div>
                                        )}

                                        <input
                                          type="file"
                                          id={`choose-photo-${patient.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0]
                                            if (!file || !patient?.patient_id) return

                                            const previewUrl = URL.createObjectURL(file)
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patient.patient_id]: previewUrl,
                                            }))

                                            try {
                                              await handleUploadPatientPhoto(patient, file)
                                            } catch (err) {
                                              console.error("Upload error:", err)
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev }
                                                delete updated[patient.patient_id]
                                                return updated
                                              })
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="media-body w-100">
                                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center flex-wrap mb-2">
                                        <h5
                                          className="mb-1 d-flex align-items-center"
                                          style={{
                                            gap: "8px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden"
                                          }}
                                        >
                                          <span>{formatName(patient.name)}</span>

                                          {/* Partner */}
                                          {patient.partner_name && (
                                            <span className="d-flex align-items-center" style={{ gap: "4px" }}>
                                              <img
                                                src={connect}
                                                alt="Partner"
                                                width="18"
                                                height="18"
                                                style={{ cursor: "pointer" }}
                                                title={`Call ${patient.partner_name}`}
                                                onClick={() => {
                                                  if (patient.partner_phone) {
                                                    window.location.href = `tel:${patient.partner_phone}`;
                                                  }
                                                }}
                                              />
                                              <span style={{ fontSize: "14px", color: "#6c757d" }}>
                                                {patient.partner_name}
                                              </span>
                                            </span>
                                          )}

                                          {/* Status */}
                                          <span className="badge bg-primary">{patient.status}</span>

                                          {/* Loader / Share */}

                                        </h5>


                                        <div
                                          className="d-flex align-items-center justify-content-end mb-2"
                                          style={{ gap: "10px" }}
                                        >
                                          {isEmergencyPatient(patient) && (
                                            <div
                                              style={{
                                                backgroundColor: "#dc3545",
                                                color: "white",
                                                padding: "4px 10px",
                                                borderRadius: "12px",
                                                fontSize: "11px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                                boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
                                                lineHeight: 1,
                                              }}
                                            >
                                              <i className="fas fa-exclamation-triangle"></i>
                                              EMERGENCY
                                            </div>
                                          )}

                                          <Link
                                            to="#"
                                            title="Preview Patient"
                                            onClick={(e) => {
                                              e.preventDefault()
                                              handlePatientClick(patient)
                                            }}
                                          >
                                            <i className="fa fa-eye text-primary fs-6"></i>
                                          </Link>

                                          <img
                                            src={icon1}
                                            alt="Case Paper"
                                            title="Open & Share Case Paper"
                                            onClick={() => handleOpenAndShare(patient?.patient_id || patient?.id)}
                                            style={{ cursor: "pointer", width: "20px", height: "20px" }}
                                          />

                                          {!canPerformActions(patient) ? (
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center"
                                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                              title="Please ask reception to scan patient first"
                                              onClick={showScanPatientAlert}
                                            >
                                              <img
                                                src={icon}
                                                alt="Vitals Disabled"
                                                style={{
                                                  width: "24px",
                                                  height: "24px",
                                                  filter: "grayscale(100%)",
                                                }}
                                              />
                                            </span>
                                          ) : actionLoading.vitalsOpening &&
                                            (actionLoading.vitalsOpening === patient.queue_id ||
                                              actionLoading.vitalsOpening === patient.patient_id) ? (
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          ) : (
                                            <Link
                                              to="#"
                                              onClick={(e) => {
                                                e.preventDefault()
                                                handleVitalsOpen(patient)
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <img
                                                src={icon}
                                                alt="Vitals"
                                                style={{
                                                  cursor: "pointer",
                                                  width: "24px",
                                                  height: "24px",
                                                }}
                                                title="Vitals"
                                              />
                                            </Link>
                                          )}

                                          <img
                                            src={call}
                                            alt="Call"
                                            width="24"
                                            height="24"
                                            className="cursor-pointer"
                                            title={`Call ${patient.name}`}
                                            onClick={() => (window.location.href = `tel:${patient.whatsapp_contact_no}`)}
                                          />

                                          {patient.questionnaire_filled?.trim().toLowerCase() === "yes" ? (
                                            actionLoading.markingCurrent === getLoadingId(patient) ? (
                                              <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                            ) : (
                                              <img
                                                src={Markcurrent}
                                                alt="Mark Current"
                                                width="24"
                                                height="24"
                                                className="cursor-pointer"
                                                title="Mark as Current"
                                                onClick={() => handleMarkCurrent(patient)}
                                                style={{
                                                  opacity: isPaused || actionLoading.markingCurrent === getLoadingId(patient) ? 0.5 : 1,
                                                }}
                                              />
                                            )
                                          ) : (
                                            <img
                                              src={Markcurrent}
                                              alt="Mark Current Disabled"
                                              width="24"
                                              height="24"
                                              className="cursor-pointer"
                                              title="Please ensure questionnaire is filled first"
                                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                                              onClick={() =>
                                                Swal.fire({
                                                  icon: "info",
                                                  title: "Action Required",
                                                  html: `Please ensure the <b>Questionnaire</b> is filled before marking the patient as current.`,
                                                  confirmButtonText: "OK",
                                                })
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {[
                                          patient.marital_status,
                                          patient.diseases,
                                          patient.mode && patient.mode.trim() !== "" ? patient.mode : "Offline",
                                          patient.timeSlot,
                                          `Dr. ${patient.doctor}`
                                        ].filter(Boolean).join(" | ")}
                                      </p>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {patient.whatsapp_contact_no && (
                                          <> {patient.whatsapp_contact_no}</>
                                        )}
                                        {patient.whatsapp_contact_no && patient.location && " | "}
                                        {patient.location && (
                                          <> {patient.location}</>
                                        )}
                                      </p>

                                      <div
                                        className="d-flex flex-wrap align-items-center gap-2"
                                        style={{ rowGap: "6px" }}
                                      >
                                        {patient.showCollectButton && (
                                          <img
                                            src={collectpayment}
                                            alt="Collect Payment"
                                            width={28}
                                            height={28}
                                            className="cursor-pointer"
                                            title="Collect Payment"
                                            onClick={() => handleCollectPayment(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                            title="Please ask reception to scan patient first"
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={cancel}
                                              alt="Cancel Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.removing &&
                                          (actionLoading.removing === patient.queue_id ||
                                            actionLoading.removing === patient.patient_id) ? (
                                          <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={cancel}
                                            alt="Cancel Appointment"
                                            width={28}
                                            height={28}
                                            className="cursor-pointer"
                                            title="Cancel Appointment"
                                            onClick={() => handleRemovePatient(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                            title="Please ask reception to scan patient first"
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={emergencyIcon}
                                              alt="Emergency Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.emergencyMarking &&
                                          (actionLoading.emergencyMarking === patient.queue_id ||
                                            actionLoading.emergencyMarking === patient.patient_id) ? (
                                          <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={emergencyIcon}
                                            alt="Emergency"
                                            width="24"
                                            height="24"
                                            className="cursor-pointer"
                                            title={isEmergencyPatient(patient) ? "Emergency Set" : "Mark as Emergency"}
                                            style={{
                                              opacity: (actionLoading.emergencyMarking &&
                                                (actionLoading.emergencyMarking === patient.queue_id ||
                                                  actionLoading.emergencyMarking === patient.patient_id)) ? 0.5 : 1
                                            }}
                                            onClick={() => handleEmergency(patient)}
                                          />
                                        )}

                                        {isLastPatientInQueue(patient) && (
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => handleMarkComplete(patient)}
                                            title="Mark as Complete"
                                            disabled={actionLoading.completing === patient.queue_id}
                                          >
                                            {actionLoading.completing === patient.queue_id ? (
                                              <>
                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                Completing...
                                              </>
                                            ) : (
                                              <i className="fas fa-check-double me-1"></i>
                                            )}
                                          </button>
                                        )}

                                        {actionLoading.sendingReminder === patient.id ? (
                                          <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                        ) : (
                                          <img
                                            src={remainder}
                                            alt="Send Reminder"
                                            width={28}
                                            height={28}
                                            className="cursor-pointer"
                                            title="Send Reminder"
                                            onClick={() => handleSendReminder(patient.id)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {patient.showReceiptIcon && (
                                          <div className="d-flex align-items-center">
                                            {actionLoading.downloading === patient.payment_id ? (
                                              <div
                                                className="spinner-border text-primary"
                                                role="status"
                                                style={{ width: "24px", height: "24px" }}
                                              >
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            ) : (
                                              <img
                                                src={pdfIcon}
                                                alt="Download PDF"
                                                width={24}
                                                height={24}
                                                style={{ cursor: "pointer" }}
                                                title="Download Receipt"
                                                onClick={() =>
                                                  handleDownloadReceipt(
                                                    patient.receipt_download_link,
                                                    patient.payment_id
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            )
                          })()}
                        </ul>
                      ) : (
                        <div className="d-flex justify-content-center align-items-center border rounded" style={{ height: "150px", minHeight: "150px" }}>
                          <p className="text-muted text-center m-0">No next patient.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Right Column - Patient Queue */}
                <div className="col-xl-6 col-xxl-6 col-lg-6" style={{ display: "flex", flexDirection: "column", height: "auto" }}>
                  <div className="border-0 pb-0" style={{ display: "flex", flexDirection: "column", overflow: "visible" }}>
                    <div className="pb-0 d-flex flex-wrap justify-content-between align-items-center gap-2" style={{ marginTop: "-5px", flexShrink: 0 }}>
                      <h4 className="card-title mb-0" style={{ fontWeight: 600 }}>
                        Patient Queue
                      </h4>
                      {(waitingPatients?.length || 0) > 0 && (
                        <button
                          className={`btn btn-sm ${isPaused ? "btn-success" : "btn-warning"}`}
                          onClick={handlePauseAll}
                          disabled={actionLoading.pausing}
                        >
                          {actionLoading.pausing && <span className="spinner-border spinner-border-sm me-2"></span>}
                          {isPaused ? "Resume" : "Pause Queue"}
                        </button>
                      )}
                    </div>
                    <div
  className="pt-3"
  style={{
    display: "flex",
    flexDirection: "column"
  }}
>
                      <div
                        id="DZ_W_Todo5"
                        className="widget-media dz-scroll"
                        style={{
                          overflowY: "auto",
                          marginTop: "-12px",
                          paddingRight: "10px",
                          scrollBehavior: "smooth",
                          maxHeight: "670px"
                        }}
                      >
                        { waitingPatients.length === 0 ? (
                          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100px", padding: "20px" }}>
                            <p className="text-muted text-center m-0">No patients in queue.</p>
                          </div>
                        ) : (
                          <ul className="timeline">
                            {waitingPatients.map((patient, index) => {
                              const loadingId = getLoadingId(patient);
                              return (
                                <li key={patient.id || patient.queue_id}>
                                  <div
                                    className="timeline-panel"
                                    style={{
                                      backgroundColor: isEmergencyPatient(patient)
                                        ? "rgba(220, 53, 69, 0.1)"
                                        : patient.is_presented === "No"
                                          ? "#e9ecef"
                                          : patient.questionnaire_filled === "No"
                                            ? "rgba(255, 159, 64, 0.15)"
                                            : "transparent",
                                      border: isEmergencyPatient(patient)
                                        ? "2px solid rgba(220, 53, 69, 0.3)"
                                        : patient.is_presented === "No"
                                          ? "2px solid #ced4da"
                                          : patient.questionnaire_filled === "No"
                                            ? "2px solid rgba(255, 159, 64, 0.5)"
                                            : "1px solid #e9ecef",
                                      borderRadius: "8px",
                                      padding: "15px",
                                      marginBottom: "10px",
                                      transition: "all 0.3s ease",
                                      position: "relative",
                                    }}
                                  >
                                    <div className="media me-2">
                                      <div style={{ position: "relative", display: "inline-block" }}>
                                        {actionLoading.uploadingPhoto === patient.patient_id ? (
                                          <div className="d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px" }}>
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              width: "50px",
                                              height: "50px",
                                              borderRadius: "50%",

                                            }}
                                          >
                                            <img
                                              alt="avatar"
                                              src={
                                                photoPreviews[patient.patient_id] ||
                                                getValidPhotoUrl(patient?.patient_photo)
                                              }
                                              onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = defaultAvatar;
                                              }}
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover", // ✅ ensures full fill
                                                display: "block",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => setPhotoModalPatient(patient)}
                                            />
                                          </div>
                                        )}

                                        <input
                                          type="file"
                                          id={`choose-photo-${patient?.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0]
                                            const patientId = patient?.patient_id

                                            if (!file) {
                                              Swal.fire("Error", "No file selected", "error")
                                              return
                                            }

                                            if (!patientId) {
                                              Swal.fire("Error", "Patient ID not found. Please refresh and try again.", "error")
                                              return
                                            }

                                            const previewUrl = URL.createObjectURL(file)
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patientId]: previewUrl,
                                            }))

                                            try {
                                              await handleUploadPatientPhoto(patient, file)
                                            } catch (err) {
                                              console.error("Upload error:", err)
                                              Swal.fire("Error", "Upload failed", "error")
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev }
                                                delete updated[patientId]
                                                return updated
                                              })
                                            }
                                          }}
                                        />

                                        <input
                                          type="file"
                                          id={`take-photo-${patient.patient_id}`}
                                          accept="image/jpeg,image/png"
                                          capture="environment"
                                          style={{ display: "none" }}
                                          onChange={async (e) => {
                                            const file = e.target.files[0]
                                            if (!file || !patient?.patient_id) return

                                            const previewUrl = URL.createObjectURL(file)
                                            setPhotoPreviews((prev) => ({
                                              ...prev,
                                              [patient.patient_id]: previewUrl,
                                            }))

                                            try {
                                              await handleUploadPatientPhoto(patient, file)
                                            } catch (err) {
                                              console.error("Upload error:", err)
                                              Swal.fire("Error", "Upload failed", "error")
                                              setPhotoPreviews((prev) => {
                                                const updated = { ...prev }
                                                delete updated[patient.patient_id]
                                                return updated
                                              })
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="media-body w-100">
                                      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center flex-wrap mb-2">
                                        <h5
                                          className="mb-1"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            flexWrap: "wrap"
                                          }}
                                        >
                                          {formatName(patient?.name)}



                                          {patient?.partner_name && (
                                            <span
                                              className="d-flex align-items-center"
                                              style={{ gap: "6px" }}
                                            >
                                              <img
                                                src={connect}
                                                alt="Partner"
                                                width="18"
                                                height="18"
                                                style={{ cursor: "pointer" }}
                                                title={`Call ${patient.partner_name}`}
                                                onClick={() => {
                                                  if (patient?.partner_phone) {
                                                    window.location.href = `tel:${patient.partner_phone}`
                                                  }
                                                }}
                                              />
                                              <span>{patient.partner_name}</span>
                                            </span>
                                          )}
                                          <span className="badge bg-primary ms-1">
                                            {patient?.status}
                                          </span>

                                        </h5>

                                        <div
                                          className="d-flex align-items-center justify-content-end mb-2"
                                          style={{ gap: "10px" }}
                                        >
                                          {isEmergencyPatient(patient) && (
                                            <div
                                              style={{
                                                backgroundColor: "#dc3545",
                                                color: "white",
                                                padding: "4px 10px",
                                                borderRadius: "12px",
                                                fontSize: "11px",
                                                fontWeight: "600",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                                boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
                                                lineHeight: 1,
                                              }}
                                            >
                                              <i className="fas fa-exclamation-triangle"></i>
                                              EMERGENCY
                                            </div>
                                          )}
                                          {(() => {
                                            const status = getPatientStatus(patient);
                                            if (!status) return null;

                                            return (
                                              <div
                                                style={{
                                                  backgroundColor: status.priority === 1 ? "rgba(220, 53, 69, 0.1)" : "rgba(100, 100, 100, 0.05)",
                                                  color: status.color,
                                                  padding: "4px 8px",
                                                  borderRadius: "4px",
                                                  fontSize: "11px",
                                                  fontWeight: "600",
                                                  display: "inline-flex",
                                                  flexDirection: "column",
                                                  gap: "2px",
                                                  lineHeight: 1.2,
                                                  border: `1px solid ${status.color}33`,
                                                  whiteSpace: "nowrap"
                                                }}
                                              >
                                                <span style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                                  <i className={status.icon}></i>
                                                  <strong>{status.label}</strong>
                                                </span>
                                                {status.message && (
                                                  <span style={{ fontSize: "9px", fontWeight: "400", opacity: 0.9 }}>
                                                    {status.message}
                                                  </span>
                                                )}
                                              </div>
                                            );
                                          })()}
                                          <Link
                                            to="#"
                                            title="Preview Patient"
                                            onClick={(e) => {
                                              e.preventDefault()
                                              handlePatientClick(patient)
                                            }}
                                          >
                                            <i className="fa fa-eye text-primary fs-6"></i>
                                          </Link>

                                          <img
                                            src={icon1}
                                            alt="Case Paper"
                                            title="Open & Share Case Paper"
                                            onClick={() => handleOpenAndShare(patient?.patient_id || patient?.id)}
                                            style={{ cursor: "pointer", width: "20px", height: "20px" }}
                                          />

                                          {!canPerformActions(patient) ? (
                                            <span
                                              className="d-inline-flex align-items-center justify-content-center"
                                              style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                              title="Please ask reception to scan patient first"
                                              onClick={showScanPatientAlert}
                                            >
                                              <img
                                                src={icon}
                                                alt="Vitals Disabled"
                                                style={{
                                                  width: "24px",
                                                  height: "24px",
                                                  filter: "grayscale(100%)",
                                                }}
                                              />
                                            </span>
                                          ) : actionLoading.vitalsOpening &&
                                            (actionLoading.vitalsOpening === patient.queue_id ||
                                              actionLoading.vitalsOpening === patient.patient_id) ? (
                                            <span
                                              className="spinner-border spinner-border-sm text-primary"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <Link
                                              to="#"
                                              onClick={(e) => {
                                                e.preventDefault()
                                                handleVitalsOpen(patient)
                                              }}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <img
                                                src={icon}
                                                alt="Vitals"
                                                style={{
                                                  cursor: "pointer",
                                                  width: "24px",
                                                  height: "24px",
                                                }}
                                                title="Vitals"
                                              />
                                            </Link>
                                          )}

                                          <img
                                            src={call}
                                            alt="Call"
                                            width="24"
                                            height="24"
                                            className="cursor-pointer"
                                            title={`Call ${patient.name}`}
                                            onClick={() => (window.location.href = `tel:${patient.whatsapp_contact_no}`)}
                                          />

                                          {patient.questionnaire_filled?.trim().toLowerCase() === "yes" ? (
                                            actionLoading.markingNext === loadingId ? (
                                              <span
                                                className="spinner-border spinner-border-sm text-primary"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            ) : (
                                              <img
                                                src={Markasnext}
                                                alt="Mark Next"
                                                width="24"
                                                height="24"
                                                className="cursor-pointer"
                                                title="Mark as Next"
                                                onClick={() => handleMarkNext(patient)}
                                                style={{
                                                  opacity:
                                                    isPaused ||
                                                      actionLoading.markingNext === loadingId
                                                      ? 0.5
                                                      : 1,
                                                }}
                                              />
                                            )
                                          ) : (
                                            <img
                                              src={Markasnext}
                                              alt="Mark Next Disabled"
                                              width="24"
                                              height="24"
                                              className="cursor-pointer"
                                              title="Please ensure questionnaire is filled first"
                                              style={{ opacity: 0.5, cursor: "not-allowed" }}
                                              onClick={() =>
                                                Swal.fire({
                                                  icon: "info",
                                                  title: "Action Required",
                                                  html: `Please ensure the <b>Questionnaire</b> is filled before marking the patient as next.`,
                                                  confirmButtonText: "OK",
                                                })
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {[
                                          patient.marital_status,
                                          patient.diseases,
                                          patient.mode && patient.mode.trim() !== "" ? patient.mode : "Offline",
                                          patient.timeSlot,
                                          patient.doctor && `Dr ${patient.doctor}`
                                        ].filter(Boolean).join(" | ")}
                                      </p>

                                      <p
                                        className="mb-1 small"
                                        style={{
                                          color: "#6c757d",
                                          fontSize: "14px",
                                          fontWeight: 500
                                        }}
                                      >
                                        {patient.whatsapp_contact_no && (
                                          <> {patient.whatsapp_contact_no}</>
                                        )}
                                        {patient.whatsapp_contact_no && patient.location && " | "}
                                        {patient.location && (
                                          <> {patient.location}</>
                                        )}
                                      </p>

                                      <div
                                        className="d-flex flex-wrap align-items-center gap-2"
                                        style={{ rowGap: "6px" }}
                                      >
                                        {patient.showCollectButton && (
                                          <img
                                            src={collectpayment}
                                            alt="Collect Payment"
                                            width={28}
                                            height={28}
                                            className="cursor-pointer"
                                            title="Collect Payment"
                                            onClick={() => handleCollectPayment(patient)}
                                            style={{
                                              padding: "4px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        )}

                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                            title="Please ask reception to scan patient first"
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={cancel}
                                              alt="Cancel Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.removing &&
                                          (actionLoading.removing === patient.queue_id ||
                                            actionLoading.removing === patient.patient_id) ? (
                                          <span
                                            className="spinner-border spinner-border-sm text-danger"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <img
                                            src={cancel}
                                            alt="Cancel Appointment"
                                            width={28}
                                            height={28}
                                            className="cursor-pointer"
                                            title="Cancel Appointment"
                                            onClick={() => handleRemovePatient(patient)}
                                            style={{ padding: "4px", objectFit: "contain" }}
                                          />
                                        )}

                                        {!canPerformActions(patient) ? (
                                          <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "28px", height: "28px", opacity: 0.5, cursor: "not-allowed" }}
                                            title="Please ask reception to scan patient first"
                                            onClick={showScanPatientAlert}
                                          >
                                            <img
                                              src={emergencyIcon}
                                              alt="Emergency Disabled"
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                filter: "grayscale(100%)",
                                              }}
                                            />
                                          </span>
                                        ) : actionLoading.emergencyMarking &&
                                          (actionLoading.emergencyMarking === patient.queue_id ||
                                            actionLoading.emergencyMarking === patient.patient_id) ? (
                                          <span
                                            className="spinner-border spinner-border-sm text-danger"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <img
                                            src={emergencyIcon}
                                            alt="Emergency"
                                            width="24"
                                            height="24"
                                            className="cursor-pointer"
                                            title={isEmergencyPatient(patient) ? "Emergency Set" : "Mark as Emergency"}
                                            style={{
                                              opacity:
                                                (actionLoading.emergencyMarking &&
                                                  (actionLoading.emergencyMarking === patient.queue_id ||
                                                    actionLoading.emergencyMarking === patient.patient_id))
                                                  ? 0.5
                                                  : 1,
                                            }}
                                            onClick={() => handleEmergency(patient)}
                                          />
                                        )}

                                        {isLastPatientInQueue(patient) && (
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() => handleMarkComplete(patient)}
                                            title="Mark as Complete"
                                            disabled={actionLoading.completing === patient.queue_id}
                                          >
                                            {actionLoading.completing === patient.queue_id ? (
                                              <>
                                                <span className="spinner-border spinner-border-sm me-1"></span>
                                                Completing...
                                              </>
                                            ) : (
                                              <i className="fas fa-check-double me-1"></i>
                                            )}
                                          </button>
                                        )}

                                        {patient.showReminder && (
                                          actionLoading.sendingReminder === patient.id ? (
                                            <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                                          ) : (
                                            <img
                                              src={remainder}
                                              alt="Send Reminder"
                                              width={28}
                                              height={28}
                                              className="cursor-pointer"
                                              title="Send Reminder"
                                              onClick={() => handleSendReminder(patient.id)}
                                              style={{
                                                padding: "4px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          )
                                        )}

                                        {patient.showReceiptIcon && (
                                          <div className="d-flex align-items-center">
                                            {actionLoading.downloading === patient.payment_id ? (
                                              <div
                                                className="spinner-border text-primary"
                                                role="status"
                                                style={{ width: "24px", height: "24px" }}
                                              >
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            ) : (
                                              <img
                                                src={pdfIcon}
                                                alt="Download PDF"
                                                width={24}
                                                height={24}
                                                style={{ cursor: "pointer" }}
                                                title="Download Receipt"
                                                onClick={() =>
                                                  handleDownloadReceipt(
                                                    patient.receipt_download_link,
                                                    patient.payment_id
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                        )}
                                        {patient?.questionnaire_filled !== "Yes" && (
                                          sendingLinkPatientId === patient?.patient_id ? (
                                            <div style={{ width: "24px", height: "24px" }}>
                                              <Loader size="sm" />
                                            </div>
                                          ) : (
                                            <img
                                              src={Sharelink || "/placeholder.svg"}
                                              alt="Send Link"
                                              title="Send Form Link"
                                              className="ms-sm-1"
                                              style={{
                                                cursor: "pointer",
                                                width: "24px",
                                                height: "24px"
                                              }}
                                              onClick={() => handleSendLink(patient?.patient_id)}
                                            />
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Emergency and Repeat Medicine Section */}
      <div className="row mt-3 mb-3">
        <div className="card border-0">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-6">
                <h4 className="card-title mb-3">Emergency Patients</h4>
                <div style={{ maxHeight: "450px", overflowY: "auto", overflowX: "hidden" }}>
                  {emergencyPatientList.length === 0 ? (
                    <p className="text-muted text-center">No emergency patients.</p>
                  ) : (
                    emergencyPatientList.map((patient) => {
                      const fullName = [
                        patient.first_name,
                        patient.middile_name,
                        patient.last_name,
                      ].filter(Boolean).join(" ")

                      const formattedDate = patient.date
                        ? new Date(patient.date).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        : "-"

                      return (
                        <div className="col-12" key={patient.queue_id}>
                          <div className="p-3 h-100 border-bottom bg-white rounded shadow-sm mb-2">
                            <div className="d-flex align-items-center gap-3">
                            <div className="flex-grow-1 overflow-hidden">
    <strong className="d-block text-truncate">
      {fullName || "N/A"}
    </strong>

    {(patient.mode || patient.time_slot || formattedDate) && (
      <p className="mb-0 small text-muted text-wrap">
        {[patient.mode, patient.time_slot, formattedDate]
          .filter(Boolean)
          .join(" | ")}
      </p>
    )}
  </div>

                              <div className="ms-auto d-flex align-items-center">
                                {patient.service_call_frequency && patient.feedback ? (
                                  <div className="text-info small me-2">
                                    ✔ Feedback Added
                                  </div>
                                ) : (
                                  <button
                                    className="btn btn-sm btn-outline-primary me-2 py-0 px-2"
                                    style={{ fontSize: "11px", lineHeight: "2" }}
                                    onClick={() => {
                                      setSelectedEmergencyPatient(patient)
                                      setShowEmergencyFeedbackModal(true)
                                    }}
                                  >
                                    Add Feedback
                                  </button>
                                )}

                                <Link
                                  to="#"
                                  className="me-2"
                                  title="Preview Patient"
                                  onClick={(e) => {
                                    e.preventDefault()
                                    handlePatientClick(patient)
                                  }}
                                >
                                  <i className="fa fa-eye text-primary fs-6"></i>
                                </Link>

                                <img
                                  src={icon1}
                                  className="me-2"
                                  alt="Case Paper"
                                  title="Open & Share Case Paper"
                                  onClick={() => handleOpenAndShare(patient.patient_id)}
                                  style={{ cursor: "pointer", width: "24px", height: "24px" }}
                                />

                                <img
                                  src={stopPrescription}
                                  alt="Prescription History"
                                  title="Prescription History"
                                  onClick={() => handleOpenPrescriptionHistory(patient)}
                                  style={{
                                    cursor: "pointer",
                                    width: "28px",
                                    height: "28px",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  )}
                </div>
              </div>

              <PrescriptionHistoryModal
                show={showPrescriptionHistory}
                onHide={() => setShowPrescriptionHistory(false)}
                rawPrescriptions={selectedPrescriptions}
                prescriptionData={selectedPrescriptions}
                patientDetails={selectedPatientForPrescription}
                handleViewClick={handleViewPrescription}
              />

              <div className="col-lg-6">
                <h4 className="card-title mb-3">Repeat Medicine</h4>
                <div
  style={{
    maxHeight: "450px",
    overflowY: "auto",
    overflowX: "hidden",
  }}
>

  {repeatPatients?.filter(
    (p) =>
      p &&
      p.patient_id &&
      p.regenerate_prescription !== "Yes"
  ).length === 0 ? (

    <p className="text-muted text-center">
      No repeat medicine patients.
    </p>

  ) : (

    repeatPatients
      ?.filter(
        (p) =>
          p &&
          p.patient_id &&
          p.regenerate_prescription !== "Yes"
      )
      .map((p) => (

        <div
          className="col-12"
          key={p.patient_id}
        >

          <div className="p-3 h-100 border-bottom">

            <div className="d-flex align-items-center">

              <div>

                <strong>

                  {[
                    p.first_name,
                    p.middile_name,
                    p.last_name,
                  ]
                    .filter(Boolean)
                    .join(" ")}

                </strong>

              </div>

              <button
                className="btn btn-sm btn-outline-primary ms-auto"
                onClick={() =>
                  handleViewPrescription(p)
                }
              >
                View prescription
              </button>

            </div>

          </div>

        </div>

      ))

  )}

</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal show={showVitalsModal} onHide={handleVitalsClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Patient Vitals</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card shadow-none">
            <div className="card-body">
              <h5 className="font-weight-bold mb-4">Blood Pressure</h5>
              <form onSubmit={handleOnSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="systolicBP" className="form-label">
                      Systolic BP (mmHg)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Systolic BP (mmHg) here.."
                      id="systolicBP"
                      name="systolicBP"
                      value={vitalsPatient?.systolicBP || ""}
                      onChange={handleVitalsChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="diastolicBP" className="form-label">
                      Diastolic BP (mmHg)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Diastolic BP (mmHg) here.."
                      id="diastolicBP"
                      name="diastolicBP"
                      value={vitalsPatient?.diastolicBP || ""}
                      onChange={handleVitalsChange}
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <label className="form-label">Height</label>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Feet"
                        min="0"
                        value={vitalsPatient?.heightFeet || ""}
                        onChange={handleHeightFeetChange}
                        style={{ width: "100px" }}
                      />
                      <span>ft</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Inches"
                        min="0"
                        max="11"
                        value={vitalsPatient?.heightInches || ""}
                        onChange={handleHeightInchesChange}
                        style={{ width: "100px" }}
                      />
                      <span>in</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Centimeters"
                        value={vitalsPatient?.height || ""}
                        onChange={handleHeightCmChange}
                        style={{ width: "140px" }}
                      />
                      <span>cm</span>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="weight" className="form-label">
                      Weight (kg)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Weight (kg) here.."
                      id="weight"
                      value={vitalsPatient?.weight || ""}
                      onChange={handleWeightChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="bmi" className="form-label">
                      BMI
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bmi"
                      value={vitalsPatient?.bmi || ""}
                      readOnly
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label htmlFor="reports" className="form-label">
                      Reports Upload<small className="text-muted">(Only JPG or PNG allowed)</small>
                    </label>

                    <div className="d-flex align-items-center w-100 gap-2">
                      <input
                        type="file"
                        id="reports"
                        accept="image/jpeg, image/png"
                        capture="environment"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />

                      <div className="d-flex gap-2">
                        <label
                          htmlFor="reports"
                          className="btn btn-outline-primary mb-0 d-flex align-items-center"
                          style={{
                            height: "38px",
                            padding: "0 15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Choose Photo
                        </label>

                        <button
                          type="button"
                          className="btn btn-outline-info mb-0 d-flex align-items-center"
                          style={{
                            height: "38px",
                            padding: "0 15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            whiteSpace: "nowrap",
                          }}
                          onClick={() => {
                            localStorage.setItem("photoSource", "vitals")
                            openCameraTab()
                          }}
                        >
                          Take Photo
                        </button>
                      </div>

                      <div className="position-relative w-100">
                        <input
                          type="text"
                          className="form-control"
                          readOnly
                          style={{ height: "38px" }}
                          value={vitalsPatient?.uploadedFileName || ""}
                          placeholder="No file chosen"
                        />

                        {vitalsPatient?.uploadedFileName && (
                          <span
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontWeight: "bold",
                              fontSize: "18px",
                              lineHeight: 1,
                              color: "#dc3545",
                            }}
                            title="Clear"
                            onClick={() => {
                              setVitalsPatient((prev) => ({
                                ...prev,
                                uploadedFile: null,
                                uploadedFileName: null,
                              }))
                              setUploadedFiles([])
                              const fileInput = document.getElementById("reports")
                              if (fileInput) fileInput.value = ""
                            }}
                          >
                            ×
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {uploadedFiles.length > 0 && (
                    <div className="col-12 mt-3">
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>File Name</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {uploadedFiles.map((file, index) => (
                              <tr key={index}>
                                <td>{file.name}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-link"
                                    title="View"
                                    onClick={() => handleView(file)}
                                  >
                                    <i className="fa fa-eye fs-18" />
                                  </button>
                                  <button
                                    className="btn btn-link text-danger"
                                    title="Delete"
                                    onClick={() => handleDelete(index)}
                                  >
                                    <i className="fa fa-trash fs-18" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <button type="submit" className="btn btn-primary" disabled={submittingVitals}>
                  {submittingVitals ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <CommonPaymentModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title="Collect Payment"
        patientName={selectedPatient?.name}
        initialAmount=""
        onSubmit={handlePaymentSubmit}
        loading={actionLoading.collectingPayment}
        paymentType="appointment"
        paymentData={{
          queue_id: selectedPatient?.queue_id,
          patient_id: selectedPatient?.patient_id,
          doctor_id: selectedPatient?.doctor_id || doctorId || admin_id,
        }}
        paymentFor="APPOINTMENT"
      />

      <Modal
        show={!!photoModalPatient}
        onHide={() => setPhotoModalPatient(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Patient Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Button
            variant="primary"
            className="w-100 mb-3"
            onClick={() => {
              document.getElementById(`choose-photo-${photoModalPatient?.patient_id}`).click()
              setPhotoModalPatient(null)
            }}
          >
            <i className="fas fa-image me-2"></i> Choose Photo
          </Button>

          <Button
            variant="success"
            className="w-100"
            onClick={() => {
              localStorage.setItem("photoSource", "queue")
              localStorage.setItem("photoPatientId", photoModalPatient?.patient_id)
              setPhotoModalPatient(null)
              openCameraTab()
            }}
          >
            <i className="fas fa-camera me-2"></i> Take Photo
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        show={showPrescriptionModal}
        onHide={() => setShowPrescriptionModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Prescription
          {" "}
    
    Duration:
    {" "}

    {(() => {

      const duration =
        parseFloat(
          selectedPrescriptions?.[0]
            ?.duration || 0
        );

      if (duration === 0.25)
        return "7 Days";

      if (duration === 0.50)
        return "15 Days";

      if (duration === 0.75)
        return "22 Days";

      if (duration === 1)
        return "1 Month";

      if (duration === 1.25)
        return "1 Month 7 Days";

      if (duration === 1.50)
        return "1 Month 15 Days";

      if (duration === 1.75)
        return "1 Month 22 Days";

      if (duration === 2)
        return "2 Months";

      return `${duration} Month`;

    })()}

    

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              border: "2px solid #ddd",
              borderRadius: "5px",
              marginBottom: 0,
            }}
            className="table-responsive"
          >
            <table
              className="table header-border"
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #ddd",
                }}
              >
                <tr className="table-info">
                  <th style={{ padding: "10px", width: "50px" }}></th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Medicine Name
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Medicine Type
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Dose
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Frequency
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Quantity
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    How to Take?
                  </th>
                  <th style={{ padding: "10px", fontWeight: "bold", color: "#000" }}>
                    Anupan
                  </th>
                </tr>
              </thead>

              <tbody>
                {loadingPrescription ? (
                  <tr>
                    <td colSpan="8" className="text-center py-3">
                      Loading...
                    </td>
                  </tr>
                ) : selectedPrescriptions.length > 0 ? (
                  selectedPrescriptions.map((prescription) =>
                    prescription.medicines.map((item, index) => (
                      <tr key={`${prescription.prescription_id}-${index}`} style={{ background: "#f7f7f7" }}>
                        <td style={{ padding: "10px" }}>
                          <input type="checkbox" className="form-check-input" defaultChecked />
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.medicine_name || "-"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.is_custom === "Yes" ? "Custom" : "Regular"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.dose || "-"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.frequency || "-"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.qty || "-"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.how_to_take || "-"}
                        </td>
                        <td style={{ padding: "10px" }}>
                          {item.anupan || "-"}
                        </td>
                      </tr>
                    ))
                  )
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-3">
                      No medicines found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* <button
            className="btn btn-success w-100 mt-3"
            onClick={async () => {
              if (!selectedPrescriptions?.length) return

              setActionLoading(prev => ({ ...prev, generatingPrescription: true }))

              const prescriptionId = selectedPrescriptions[0].prescription_id
              const result = await dispatch(regeneratePrescriptionAction(prescriptionId))

              setActionLoading(prev => ({ ...prev, generatingPrescription: false }))

              if (result?.success) {
                handleSuccess("Prescription regenerated.")
                setShowPrescriptionModal(false)
              } 
              else {
                showErrorAlert("Failed to regenerate.")
              }
            }}
            disabled={actionLoading.generatingPrescription}
          >
            {actionLoading.generatingPrescription ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Generating...
              </>
            ) : (
              "Generate Prescription"
            )}
          </button> */}
          <button
  className="btn btn-success w-100 mt-3"
  onClick={async () => {

    if (
      !selectedPrescriptions?.length
    ) return;

    setActionLoading(prev => ({
      ...prev,
      generatingPrescription: true
    }));

    try {

      const prescriptionId =
        selectedPrescriptions[0]
          .prescription_id;

      const result =
        await dispatch(
          regeneratePrescriptionAction(
            prescriptionId
          )
        );

      if (result?.success) {

        // REFRESH REPEAT PRESCRIPTION LIST
        const refreshed =
          await getRepeatPrescriptionList(
            doctorId
          );

        if (
          refreshed?.data?.status ===
          "success"
        ) {

          const prescriptions =
            refreshed?.data?.data || [];

          const mergedData =
            prescriptions.map((pres) => ({
              ...pres,
              disease_name: "-",
              last_visit_date: "-",
            }));

          // UPDATE LEFT LIST
          setRepeatPatients(
            mergedData
          );

          // CHECK PATIENT EXISTS
          const patientStillExists =
            mergedData.some(
              (p) =>
                p.patient_id ===
                selectedPatient?.patient_id
            );

          // REMOVE RIGHT SIDE DATA
          // IF PATIENT REMOVED
          if (!patientStillExists) {

            setSelectedPatient(null);

            setSelectedPrescriptions([]);

          }

        }

        // ALWAYS CLOSE MODAL
        setShowPrescriptionModal(
          false
        );

        handleSuccess(
          "Prescription regenerated."
        );

      } else {

        showErrorAlert(
          "Failed to regenerate."
        );

      }

    } catch (error) {

      console.error(error);

      showErrorAlert(
        "Something went wrong."
      );

    } finally {

      setActionLoading(prev => ({
        ...prev,
        generatingPrescription: false
      }));

    }

  }}
  disabled={
    actionLoading.generatingPrescription
  }
>
  {actionLoading.generatingPrescription ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Generating...
    </>
  ) : (
    "Generate Prescription"
  )}
</button>
        </Modal.Body>
      </Modal>

      <EmergencyFeedbackModal
        show={showEmergencyFeedbackModal}
        onClose={() => setShowEmergencyFeedbackModal(false)}
        onSave={handleEmergencyFeedbackSave}
      />
    </div>
  )
}

export default Doctor
